import http from "./http.js";

async function getSpecifications(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = "",
    sort = ""
) {
  let filterParams = "";
  filterParams +=
    filter && filter.client && filter.client.id
      ? `&filter.clientId=${filter.client.id}`
      : "";
  filterParams += filter && filter.lead ? `&filter.lead=${filter.lead}` : "";
  filter && filter.users.length
    ? filter.users.forEach((user) => {
      filterParams += `&filter.authorIds=${user.id}`;
    })
    : "";
  filterParams += filter && filter.onlyExceededLimit ? `&filter.onlyExceededLimit=${filter.onlyExceededLimit}` : "";
  let sortParams = "";
  for (const key in sort) {
    sortParams += `&${key}=${sort[key]}`;
  }
  try {
    const response = await http.get(
      `specifications?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filterParams}${sortParams}`,
      {}
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function getSpecification(specId) {
  try {
    const response = await http.get(`specifications/${specId}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function createSpecification(specification) {
  try {
    const response = await http.post("specifications", specification);
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function setClientSpecification(specId, clientId) {
  try {
    const response = await http.patch(
      `specifications/${specId}/rpc/bind-to-client/${clientId}`
    );
    return response;
  } catch (err) {
    throw err;
  }
}

async function setTrackerSpecification(specId, issueTrackerRef) {
  try {
    const response = await http.patch(
      `specifications/${specId}/rpc/assign-issue-tracker`,
      {
        value: issueTrackerRef,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
}

async function createSpecificationItem(specId, items) {
  try {
    const response = await http.post(`specifications/${specId}/items`, {
      title: items.title,
      section: items.section,
      sectionPosition: items.sectionPosition,
    });
    return response;
  } catch (err) {
    throw err;
  }
}

async function updateItemTitle(specId, itemId, itemTitle) {
  try {
    const response = await http.patch(
      `specifications/${specId}/items/${itemId}/rpc/rename`,
      {
        newTitle: itemTitle,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
}

async function updateItemSection(specId, itemId, itemSection) {
  try {
    const response = await http.patch(
      `specifications/${specId}/items/${itemId}/rpc/change-section`,
      {
        newSection: itemSection,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
}

async function updateSectionName(specId, newName, oldName) {
  try {
    const response = await http.patch(
      `specifications/${specId}/items/rpc/rename-section`,
      {
        oldName,
        newName,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
}

async function updateItemEstimate(specId, itemId, itemEstimate) {
  try {
    const response = await http.patch(
      `specifications/${specId}/items/${itemId}/rpc/estimate`,
      itemEstimate
    );
    return response;
  } catch (err) {
    throw err;
  }
}

async function updateItemTrack(specId, itemId, issueJiraDev, issueJiraAnalyst) {
  try {
    const response = await http.patch(
      `specifications/${specId}/items/${itemId}/rpc/assign-issue-tracker`,
      {
        issueJiraDev,
        issueJiraAnalyst,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
}

async function deleteSpecificationItem(specId, itemId) {
  try {
    await http.delete(`specifications/${specId}/items/${itemId}`);
  } catch (err) {
    throw err;
  }
}

async function deleteSpecificationSection(specId, sectionTitle) {
  try {
    const response = await http.patch(
      `specifications/${specId}/rpc/delete-section`,
      {
        sectionTitle,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
}

async function updateSpecificationTitle(specId, title) {
  try {
    const response = await http.patch(`specifications/${specId}/rpc/title`, {
      value: title,
    });
    return response;
  } catch (err) {
    throw err;
  }
}

async function changePositionSectionItem(specId, itemId, order) {
  try {
    const response = await http.patch(
      `specifications/${specId}/items/${itemId}/rpc/order`,
      {
        value: order,
      }
    );
    return response;
  } catch (err) {
    throw err;
  }
}

async function setCRMSpecification(specId, linkToCRM) {
  try {
    const response = await http.patch(`specifications/${specId}/rpc/crm`, {
      value: linkToCRM,
    });
    return response;
  } catch (err) {
    throw err;
  }
}

async function changeTestIndex(id, value) {
  try {
    const response = await http.patch(`specifications/${id}/rpc/test-index`, {
      value,
    });
    return response;
  } catch (err) {
    throw err;
  }
}

async function getClientSpecifications() {
  try {
    const response = await http.get("clients/specifications");
    return response.data;
  } catch (err) {
    throw err;
  }
}

export {
  getSpecifications,
  getSpecification,
  createSpecification,
  setClientSpecification,
  setTrackerSpecification,
  createSpecificationItem,
  updateItemTrack,
  updateItemTitle,
  updateItemSection,
  updateItemEstimate,
  deleteSpecificationItem,
  deleteSpecificationSection,
  updateSpecificationTitle,
  changePositionSectionItem,
  setCRMSpecification,
  updateSectionName,
  changeTestIndex,
  getClientSpecifications,
};
